<template>
    <va-card class="flex mb-4">
        <va-card-title style="height: 30px; padding: 5px; padding-left: 20px"
            >我的审批</va-card-title
        >
        <va-card-content>
            <div>
                <div>
                    <vxe-form :data="toolbar.formData">
                        <vxe-form-item
                            title="关键字"
                            field="searchKey"
                            :item-render="{}"
                        >
                            <template #default="{ data }">
                                <vxe-input
                                    v-model="data.searchKey"
                                    placeholder="请输入关键字"
                                    clearable
                                ></vxe-input>
                            </template>
                        </vxe-form-item>

                        <vxe-form-item>
                            <template #default>
                                <vxe-button
                                    status="primary"
                                    @click="findData"
                                    @keyup.enter="findData"
                                    >查询</vxe-button
                                >
                                <vxe-button @click="clear">重置</vxe-button>
                            </template>
                        </vxe-form-item>
                    </vxe-form>
                </div>
                <div style="overflow: hidden; height: 100%">
                    <vxe-table
                        stripe
                        class="mytable-scrollbar"
                        :data="tableData"
                        ref="xTable1"
                        :height="tableHeight"
                        show-overflow
                        :row-config="{
                            height: 36,
                            isHover: true,
                            isCurrent: true,
                        }"
                    >
                        <vxe-column
                            field="Id"
                            type="seq"
                            title="#"
                            width="20"
                        ></vxe-column>
                        <vxe-column title="状态-操作" width="100">
                            <template #default="{ row }">
                                <vxe-button
                                    status="success"
                                    @click="auditReq(row)"
                                    icon="fa fa-check"
                                    round
                                    >审核</vxe-button
                                >
                            </template>
                        </vxe-column>
                        <vxe-column
                            field="status"
                            title="状态"
                            width="200"
                            align="center"
                        >
                            <template #default="{ row }">
                                <vxe-button
                                    type="text"
                                    @click="showAuditList(row)"
                                    >{{ row.status }}</vxe-button
                                >
                            </template>
                        </vxe-column>
                        <vxe-column
                            field="auditTypeName"
                            title="审核类型"
                            show-overflow
                            width="150"
                        ></vxe-column>
                        <vxe-column
                            field="auditName"
                            title="审核名称"
                            show-overflow
                            width="200"
                        ></vxe-column>
                        <vxe-column
                            field="applyMan"
                            title="申请人"
                            width="100"
                        ></vxe-column>
                        <vxe-column
                            field="applyDate"
                            title="申请时间"
                        ></vxe-column>
                        <vxe-column
                            field="auditType"
                            title="审核类型v"
                            :visible="false"
                            width="140"
                        ></vxe-column>
                    </vxe-table>
                </div>
                <div>
                    <vxe-pager
                        background
                        v-model:current-page="tablePager.currentPage"
                        v-model:page-size="tablePager.pageSize"
                        :total="tablePager.totalResult"
                        @page-change="handlePageChange"
                        :layouts="[
                            'PrevJump',
                            'PrevPage',
                            'JumpNumber',
                            'NextPage',
                            'NextJump',
                            'Sizes',
                            'FullJump',
                            'Total',
                        ]"
                    >
                    </vxe-pager>
                </div>
            </div>
            <!--审核界面 -->
            <!--RPA流程退役申请-->
            <vxe-modal
                v-model="formInputRetire.isShow"
                @close="closeEvent"
                :title="formInputRetire.title"
                width="840"
                height="550"
                show-zoom
                resize
                remember
            >
                <template #default>
                    <vxe-form
                        :data="formInputRetire.formData"
                        :rules="formInputRetire.formRules"
                        title-align="right"
                        ref="rFormRetire"
                        title-width="60"
                    >
                        <vxe-form-item
                            title="基本信息"
                            span="24"
                            title-align="left"
                            title-width="200px"
                            :title-prefix="{ icon: 'fa fa-address-card-o' }"
                        ></vxe-form-item>
                        <vxe-form-item
                            title="流程ID"
                            field="ProcessID"
                            span="10"
                            title-width="100px"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="formInputRetire.formData.ProcessID"
                                    placeholder="请输入流程ID"
                                    :disabled="formInputRetire.allInputDisable"
                                    readonly
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item span="2">
                            <template #default> </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="流程名称"
                            field="ProcessName"
                            span="12"
                            title-width="100px"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="
                                        formInputRetire.formData.ProcessName
                                    "
                                    readonly
                                    placeholder="请输入流程名称"
                                    :disabled="formInputRetire.allInputDisable"
                                ></vxe-input>
                            </template>
                        </vxe-form-item>

                        <vxe-form-item
                            title="开发人员"
                            field="DevelopUser"
                            span="10"
                            title-width="100px"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="
                                        formInputRetire.formData.DevelopUser
                                    "
                                    placeholder="请输入开发人员"
                                    :disabled="formInputRetire.allInputDisable"
                                    readonly
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item span="2">
                            <template #default> </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="科长"
                            field="leader"
                            span="10"
                            title-width="100px"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="formInputRetire.formData.leader"
                                    readonly
                                    placeholder="请选择科长"
                                    :disabled="formInputRetire.allInputDisable"
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item span="2">
                            <template #default>
                                <vxe-button
                                    :disabled="formInputRetire.allInputDisable"
                                    >选择
                                </vxe-button>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="总部窗口"
                            field="winMan"
                            span="10"
                            title-width="100px"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="formInputRetire.formData.winMan"
                                    readonly
                                    :disabled="formInputRetire.allInputDisable"
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="退役原因"
                            field="retireReason"
                            span="24"
                            title-width="100px"
                        >
                            <template #default>
                                <vxe-textarea
                                    rows="4"
                                    v-model="
                                        formInputRetire.formData.retireReason
                                    "
                                    placeholder="请输入退役原因"
                                    maxlength="1000"
                                    :disabled="formInputRetire.allInputDisable"
                                    show-word-count
                                ></vxe-textarea>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            span="24"
                            title-align="left"
                            title-width="600px"
                            :title-prefix="{ icon: 'fa fa-check-circle-o' }"
                        >
                            <template #title>
                                <span style="color: red">审核意见</span>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item span="24">
                            <template #default>
                                <vxe-textarea
                                    rows="4"
                                    v-model="auditOpinionRPARetire"
                                    placeholder="请输入审核意见"
                                    maxlength="1000"
                                    show-word-count
                                ></vxe-textarea>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item align="center" span="24">
                            <template #default>
                                <vxe-button
                                    @click="rejectRetire"
                                    icon="fa fa-reply"
                                    status="danger"
                                    >驳回
                                </vxe-button>
                                <vxe-button
                                    @click="submitRetire"
                                    icon="fa fa-check"
                                    status="success"
                                    >通过
                                </vxe-button>
                            </template>
                        </vxe-form-item>
                    </vxe-form>
                </template>
            </vxe-modal>
            <!--RPA添加业务人员-->
            <vxe-modal
                v-model="formInputAddMan.isShow"
                @close="closeEvent"
                :title="formInputAddMan.title"
                width="840"
                height="550"
                show-zoom
                resize
                remember
            >
                <template #default>
                    <div>
                        <vxe-form
                            :data="formInputAddMan.formData"
                            :rules="formInputAddMan.formRules"
                            title-align="right"
                            ref="rFormAddMan"
                            title-width="60"
                        >
                            <vxe-form-item
                                title="流程ID"
                                field="processID"
                                span="10"
                                title-width="100px"
                            >
                                <template #default>
                                    <vxe-input
                                        v-model="
                                            formInputAddMan.formData.processID
                                        "
                                        placeholder="请输入流程ID"
                                        :disabled="
                                            formInputAddMan.allInputDisable
                                        "
                                        readonly
                                    ></vxe-input>
                                </template>
                            </vxe-form-item>
                            <vxe-form-item span="2">
                                <template #default> </template>
                            </vxe-form-item>
                            <vxe-form-item
                                title="流程名称"
                                field="processName"
                                span="12"
                                title-width="100px"
                            >
                                <template #default>
                                    <vxe-input
                                        v-model="
                                            formInputAddMan.formData.processName
                                        "
                                        readonly
                                        placeholder="请输入流程名称"
                                        :disabled="
                                            formInputAddMan.allInputDisable
                                        "
                                    ></vxe-input>
                                </template>
                            </vxe-form-item>

                            <vxe-form-item
                                title="开发人员"
                                field="developer"
                                span="10"
                                title-width="100px"
                            >
                                <template #default>
                                    <vxe-input
                                        v-model="
                                            formInputAddMan.formData.developer
                                        "
                                        placeholder="请输入开发人员"
                                        :disabled="
                                            formInputAddMan.allInputDisable
                                        "
                                        readonly
                                    ></vxe-input>
                                </template>
                            </vxe-form-item>
                            <vxe-form-item span="2">
                                <template #default> </template>
                            </vxe-form-item>
                            <vxe-form-item
                                title="原业务人员"
                                field="oldUserName"
                                span="12"
                                title-width="100px"
                            >
                                <template #default>
                                    <vxe-input
                                        v-model="
                                            formInputAddMan.formData.oldUserName
                                        "
                                        readonly
                                        placeholder=""
                                        :disabled="
                                            formInputAddMan.allInputDisable
                                        "
                                    ></vxe-input>
                                </template>
                            </vxe-form-item>
                            <vxe-form-item
                                title="新业务人员"
                                field="UserNameEmail"
                                span="10"
                                title-width="100px"
                            >
                                <template #default>
                                    <vxe-input
                                        v-model="
                                            formInputAddMan.formData
                                                .UserNameEmail
                                        "
                                        readonly
                                        placeholder="请选择新业务人员"
                                        :disabled="
                                            formInputAddMan.allInputDisable
                                        "
                                    ></vxe-input>
                                </template>
                            </vxe-form-item>
                            <vxe-form-item span="2">
                                <template #default> </template>
                            </vxe-form-item>
                            <vxe-form-item
                                title="申请原因"
                                field="reqReason"
                                span="24"
                                title-width="100px"
                            >
                                <template #default>
                                    <vxe-textarea
                                        rows="4"
                                        v-model="
                                            formInputAddMan.formData.reqReason
                                        "
                                        placeholder="请输入申请原因"
                                        maxlength="1000"
                                        :disabled="
                                            formInputAddMan.allInputDisable
                                        "
                                        show-word-count
                                    ></vxe-textarea>
                                </template>
                            </vxe-form-item>

                            <vxe-form-item
                                span="24"
                                title-align="left"
                                title-width="600px"
                                :title-prefix="{ icon: 'fa fa-check-circle-o' }"
                            >
                                <template #title>
                                    <span style="color: red">审核意见</span>
                                </template>
                            </vxe-form-item>
                            <vxe-form-item span="24">
                                <template #default>
                                    <vxe-textarea
                                        rows="4"
                                        v-model="auditOpinionAddMan"
                                        placeholder="请输入审核意见"
                                        maxlength="1000"
                                        show-word-count
                                    ></vxe-textarea>
                                </template>
                            </vxe-form-item>
                            <vxe-form-item align="center" span="24">
                                <template #default>
                                    <vxe-button
                                        @click="rejectAddMan"
                                        icon="fa fa-reply"
                                        status="danger"
                                        >驳回
                                    </vxe-button>
                                    <vxe-button
                                        @click="submitAddMan"
                                        icon="fa fa-check"
                                        status="success"
                                        >通过
                                    </vxe-button>
                                </template>
                            </vxe-form-item>
                        </vxe-form>
                    </div>
                </template>
            </vxe-modal>
            <!-- 流程停用申请申请-->
            <vxe-modal
                v-model="formInputStop.isShow"
                :title="formInputStop.title"
                width="840"
                height="550"
                show-zoom
                resize
                remember
            >
                <template #default>
                    <vxe-form
                        :data="formInputStop.formData"
                        :rules="formInputStop.formRules"
                        title-align="right"
                        ref="rFormStop"
                        title-width="60"
                    >
                        <vxe-form-item
                            title="流程ID"
                            field="processID"
                            span="10"
                            title-width="100px"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="formInputStop.formData.processID"
                                    placeholder="请输入流程ID"
                                    :disabled="formInputStop.allInputDisable"
                                    readonly
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item span="2">
                            <template #default> </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="流程名称"
                            field="processName"
                            span="12"
                            title-width="100px"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="formInputStop.formData.processName"
                                    readonly
                                    placeholder="请输入流程名称"
                                    :disabled="formInputStop.allInputDisable"
                                ></vxe-input>
                            </template>
                        </vxe-form-item>

                        <vxe-form-item
                            title="业务人员"
                            field="UserNameEmail"
                            span="10"
                            title-width="100px"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="
                                        formInputStop.formData.UserNameEmail
                                    "
                                    placeholder="请输入业务人员"
                                    :disabled="formInputStop.allInputDisable"
                                    readonly
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item span="2">
                            <template #default> </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="虚拟机"
                            field="oldUserName"
                            span="12"
                            title-width="100px"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="formInputStop.formData.oldUserName"
                                    readonly
                                    placeholder=""
                                    :disabled="formInputStop.allInputDisable"
                                ></vxe-input>
                            </template>
                        </vxe-form-item>

                        <vxe-form-item
                            title="申请原因"
                            field="reqReason"
                            span="24"
                            title-width="100px"
                        >
                            <template #default>
                                <vxe-textarea
                                    rows="4"
                                    v-model="formInputStop.formData.reqReason"
                                    placeholder="请输入停用原因"
                                    maxlength="1000"
                                    :disabled="formInputStop.allInputDisable"
                                    show-word-count
                                ></vxe-textarea>
                            </template>
                        </vxe-form-item>

                        <vxe-form-item
                            span="24"
                            title-align="left"
                            title-width="600px"
                            :title-prefix="{ icon: 'fa fa-check-circle-o' }"
                        >
                            <template #title>
                                <span style="color: red">审核意见</span>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item span="24">
                            <template #default>
                                <vxe-textarea
                                    rows="4"
                                    v-model="auditOpinionStop"
                                    placeholder="请输入审核意见"
                                    maxlength="1000"
                                    show-word-count
                                ></vxe-textarea>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item align="center" span="24">
                            <template #default>
                                <vxe-button
                                    @click="rejectStop"
                                    icon="fa fa-reply"
                                    status="danger"
                                    >驳回
                                </vxe-button>
                                <vxe-button
                                    @click="submitStop"
                                    icon="fa fa-check"
                                    status="success"
                                    >通过
                                </vxe-button>
                            </template>
                        </vxe-form-item>
                    </vxe-form>
                </template>
            </vxe-modal>
            <!-- 流程使用申请申请-->
            <vxe-modal
                v-model="formInputStart.isShow"
                :title="formInputStart.title"
                width="840"
                height="550"
                show-zoom
                resize
                remember
            >
                <template #default>
                    <vxe-form
                        :data="formInputStart.formData"
                        :rules="formInputStart.formRules"
                        title-align="right"
                        ref="rFormStop"
                        title-width="60"
                    >
                        <vxe-form-item
                            title="流程ID"
                            field="processID"
                            span="10"
                            title-width="100px"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="formInputStart.formData.processID"
                                    placeholder="请输入流程ID"
                                    :disabled="formInputStart.allInputDisable"
                                    readonly
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item span="2">
                            <template #default> </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="流程名称"
                            field="processName"
                            span="12"
                            title-width="100px"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="
                                        formInputStart.formData.processName
                                    "
                                    readonly
                                    placeholder="请输入流程名称"
                                    :disabled="formInputStart.allInputDisable"
                                ></vxe-input>
                            </template>
                        </vxe-form-item>

                        <vxe-form-item
                            title="业务人员"
                            field="UserNameEmail"
                            span="10"
                            title-width="100px"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="
                                        formInputStart.formData.UserNameEmail
                                    "
                                    placeholder="请输入业务人员"
                                    :disabled="formInputStart.allInputDisable"
                                    readonly
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item span="2">
                            <template #default> </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="虚拟机"
                            field="oldUserName"
                            span="12"
                            title-width="100px"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="
                                        formInputStart.formData.oldUserName
                                    "
                                    readonly
                                    placeholder=""
                                    :disabled="formInputStart.allInputDisable"
                                ></vxe-input>
                            </template>
                        </vxe-form-item>

                        <vxe-form-item
                            title="申请原因"
                            field="reqReason"
                            span="24"
                            title-width="100px"
                        >
                            <template #default>
                                <vxe-textarea
                                    rows="4"
                                    v-model="formInputStart.formData.reqReason"
                                    placeholder="请输入使用原因"
                                    maxlength="1000"
                                    :disabled="formInputStart.allInputDisable"
                                    show-word-count
                                ></vxe-textarea>
                            </template>
                        </vxe-form-item>

                        <vxe-form-item
                            span="24"
                            title-align="left"
                            title-width="600px"
                            :title-prefix="{ icon: 'fa fa-check-circle-o' }"
                        >
                            <template #title>
                                <span style="color: red">审核意见</span>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item span="24">
                            <template #default>
                                <vxe-textarea
                                    rows="4"
                                    v-model="auditOpinionStart"
                                    placeholder="请输入审核意见"
                                    maxlength="1000"
                                    show-word-count
                                ></vxe-textarea>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item align="center" span="24">
                            <template #default>
                                <vxe-button
                                    @click="rejectStart"
                                    icon="fa fa-reply"
                                    status="danger"
                                    >驳回
                                </vxe-button>
                                <vxe-button
                                    @click="submitStart"
                                    icon="fa fa-check"
                                    status="success"
                                    >通过
                                </vxe-button>
                            </template>
                        </vxe-form-item>
                    </vxe-form>
                </template>
            </vxe-modal>
            <!--审核记录-->
            <vxe-modal
                title="审核记录"
                v-model="isShowAudit"
                width="500"
                height="600"
            >
                <template #default>
                    <div>
                        <MyAuditLine :auditrecord-list="dtAudit"></MyAuditLine>
                    </div>
                </template>
            </vxe-modal>
        </va-card-content>
    </va-card>
    <EmpTypeChangeAudit ref="empTypeChangeApplyRef" @flashData="findData"></EmpTypeChangeAudit>
    <FrequencyChangeAudit ref="frequencyChangeApplyRef" @flashData="findData"></FrequencyChangeAudit>
</template>

<script>
import Qs from "qs";
import { reactive, ref } from "vue";
import { VXETable } from "vxe-table";
import MyAuditLine from "../myPlug/MyAuditLine";
import EmpTypeChangeAudit from "./EmpTypeChangeAudit.vue";
import FrequencyChangeAudit from "./FrequencyChangeAudit.vue";

export default {
    name: "MyAuditList",
    components: { MyAuditLine, EmpTypeChangeAudit, FrequencyChangeAudit },
    data() {
        const pageHeight = window.innerHeight - (65 + 48 + 198) + "px"; //屏幕高度减去导航栏和内补白
        const tablePager = reactive({
            currentPage: 1,
            pageSize: 10,
            totalResult: 0,
        });
        const empTypeChangeApplyRef = ref(null);
        const frequencyChangeApplyRef = ref(null);
        const toolbar = reactive({
            loading: false,
            macOptions: [],
            allStatus: [],
            formData: {
                status: "",
                searchKey: "",
            },
        });

        const formInput = reactive({
            title: "技术组审核",
            isShow: false,
            saveButDisable: false,
            allInputDisable: false,
            allTechs: [], //技术组担当
            allScenes: [], //场景组担当
            planPlatform: [], //部署平台
            digitalTypes: [], //员工类型
            allReqPlatform: [], //开发平台
            formData: {
                Id: "",
                AuditStatus: "0",
                reqNo: "", //需求编号
                ProcessName: "",
                ProcessID: "",
                processDesc: "",
                sceneBussValue: "",
                CreateMan: "",
                CreateManName: "",
                division: "",
                empType: "",
                introduction: "",
                techUID: "",
                techName: "",
                sceneUID: "",
                sceneName: "",
                UserName: "",
                UserNameEmail: "",
                UserId: "",
                UserIDName: [],
                DevPlatform: "", //开发平台
                realPlatform: "", //部署平台
                otherPlatform: "", //其他部署平台
                PubState: "",
                empVersion: "", //数字员工版本
                ManSingleTime: "",
                ManFrequency: "",
                DevelopTime: "",
                RobotSingleTime: "",
                RobotMonthRun: "",
                SingleSaveTime: "",
                MachineName: "",
                fPathPackage: "",
                fPathPdd: "",
                fPathPhoto: "",
                isPro: false, //是否生产发布
            },
            formRules: {
                reqNo: [{ required: false, message: "需求编号不能为空" }],
                ProcessID: [{ required: false, message: "开发编号不能为空" }],
                ProcessName: [
                    { required: true, message: "数字员工名称不能为空" },
                ],
                processDesc: [
                    { required: false, message: "工作场景描述不能为空" },
                ],
                sceneBussValue: [
                    { required: false, message: "场景业务价值不能为空" },
                ],
                empType: [{ required: true, message: "数字员工类型不能为空" }],
                introduction: [
                    { required: true, message: "数字员工简介不能为空" },
                ],
                techUID: [{ required: false, message: "辅导老师不能为空" }],
                sceneUID: [{ required: false, message: "场景组担当不能为空" }],
                UserNameEmail: [
                    { required: true, message: "业务人员不能为空" },
                ],
                PubState: [{ required: true, message: "发布阶段不能为空" }],
                empVersion: [
                    { required: true, message: "数字员工版本不能为空" },
                ],
                DevPlatform: [{ required: true, message: "开发平台不能为空" }],
                realPlatform: [{ required: true, message: "部署平台不能为空" }],
                otherPlatform: [
                    { required: false, message: "其他部署平台不能为空" },
                ],
                ManSingleTime: [
                    {
                        required: false,
                        message: "Before-人工每次耗时(分钟)不能为空",
                    },
                ],
                ManFrequency: [
                    { required: false, message: "Before-人工每月次数不能为空" },
                ],
                DevelopTime: [{ required: false, message: "开发时长不能为空" }],
                RobotSingleTime: [
                    {
                        required: false,
                        message: "After-每次耗时(分钟)不能为空",
                    },
                ],
                RobotMonthRun: [
                    { required: false, message: "After-每月次数不能为空" },
                ],
                fPathPackage: [{ required: true, message: "程序包不能为空" }],
                fPathPdd: [{ required: true, message: "设计文档不能为空" }],
                fPathPhoto: [
                    { required: false, message: "数字员工照片不能为空" },
                ],
            },
        });
        const formInputRetire = reactive({
            title: "数字员工退役申请审核",
            isShow: false,
            saveButDisable: false,
            allInputDisable: true,
            userSelType: 3, // 科长
            isCheck: false,
            formData: {
                Id: "",
                AuditStatus: "0",
                ProcessID: "",
                ProcessName: "",
                DevelopUser: "",
                DevelopUserUID: "",
                leader: "",
                leaderUID: "",
                retireReason: "",
                leaderIDName: [],
                winMan: "",
            },
            formRules: {
                ProcessID: [{ required: true, message: "流程ID不能为空" }],
                ProcessName: [{ required: true, message: "流程名称不能为空" }],
                DevelopUser: [{ required: true, message: "开发人员不能为空" }],
                leader: [{ required: true, message: "科长不能为空" }],
                retireReason: [{ required: true, message: "退役原因不能为空" }],
            },
        });
        const formInputAddMan = reactive({
            title: "添加业务人员申请",
            isShow: false,
            saveButDisable: false,
            allInputDisable: true,
            userSelType: 4, // 添加业务人员
            isCheck: false,
            formData: {
                Id: "",
                pubId: "",
                reqType: "1", //申请类型
                status: "0",
                processID: "",
                processName: "",
                developer: "",
                oldUserName: "",
                oldUserID: "",
                UserName: "",
                UserId: "",
                UserNameEmail: "",
                UserIDName: [],
                reqReason: "",
                creator: "",
            },
            formRules: {
                reqReason: [{ required: true, message: "申请原因不能为空" }],
                UserNameEmail: [
                    { required: true, message: "新业务人员不能为空" },
                ],
            },
        });
        const formInputStop = reactive({
            title: "数字员工停用申请",
            isShow: false,
            saveButDisable: false,
            allInputDisable: true,
            formData: {
                Id: "",
                pubId: "",
                reqType: "2", //停用
                status: "0",
                processID: "",
                processName: "",
                UserName: "",
                UserNameEmail: "",
                oldUserName: "",
                reqReason: "",
                creator: "",
            },
            formRules: {
                reqReason: [{ required: true, message: "停用原因不能为空" }],
            },
        });
        const formInputStart = reactive({
            title: "数字员工使用申请",
            isShow: false,
            saveButDisable: false,
            allInputDisable: true,
            formData: {
                Id: "",
                pubId: "",
                reqType: "3", //使用
                status: "0",
                processID: "",
                processName: "",
                UserName: "",
                UserNameEmail: "",
                oldUserName: "",
                reqReason: "",
                creator: "",
            },
            formRules: {
                reqReason: [{ required: true, message: "使用原因不能为空" }],
            },
        });
        const auditOpinion = ref("OK");

        return {
            tableData: null,
            tablePager,
            toolbar,
            pageHeight,
            formInput,
            formInputRetire,
            formInputAddMan,
            formInputStop,
            formInputStart,
            auditOpinion,
            tableHeight: 0,
            auditOpinionRPARetire: "OK",
            auditOpinionAddMan: "OK",
            auditOpinionStop: "OK",
            auditOpinionStart: "OK",
            dtAudit: null,
            isShowAudit: false,
            empTypeChangeApplyRef,
            frequencyChangeApplyRef,
        };
    },
    methods: {
        closeEvent() {
            this.findData();
        },
        auditReq(row) {
            //员工退役
            if (row.auditType === "1") {
                const params = {
                    uid: this.$store.state.userID,
                    email: this.$store.state.email,
                    currentPage: 1,
                    pageSize: 20,
                    searchKey: [row.Id],
                };
                this.$api.newPublishManageAPI
                    .getPublishOne(Qs.stringify(params))
                    .then((res) => {
                        if (res.data.Success === false) {
                            VXETable.modal.message({
                                content: res.data.Message,
                                status: "error",
                            });
                            return;
                        }

                        this.formInputRetire.formData.Id = res.data.Data.Id;
                        this.formInputRetire.formData.ProcessID =
                            res.data.Data.ProcessID;
                        this.formInputRetire.formData.ProcessName =
                            res.data.Data.ProcessName;
                        this.formInputRetire.formData.DevelopUser =
                            res.data.Data.DevelopUser;
                        this.formInputRetire.formData.DevelopUserUID =
                            res.data.Data.DevelopUserUID;
                        this.formInputRetire.formData.leader =
                            res.data.Data.leader;
                        this.formInputRetire.formData.leaderUID =
                            res.data.Data.leaderUID;
                        this.formInputRetire.formData.retireReason =
                            res.data.Data.retireReason;
                        this.formInputRetire.formData.winMan =
                            res.data.Data.curWinMan;
                        this.formInputRetire.isShow = true;
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            } else if (row.auditType === "2") {
                const params = {
                    uid: this.$store.state.userID,
                    email: this.$store.state.email,
                    currentPage: 1,
                    pageSize: 100,
                    searchKey: ["", row.Id],
                };
                this.$api.publishManageAPI
                    .getProcessAddManList(Qs.stringify(params))
                    .then((res) => {
                        if (res.data.Success == false) {
                            VXETable.modal.message({
                                content: res.data.Message,
                                status: "error",
                            });
                            return;
                        }
                        console.log(res.data.Data);
                        this.formInputAddMan.formData =
                            res.data.Data.dataTable[0];
                        this.formInputAddMan.isShow = true;
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            } else if (row.auditType === "3") {
                const params = {
                    uid: this.$store.state.userID,
                    email: this.$store.state.email,
                    currentPage: 1,
                    pageSize: 100,
                    searchKey: ["", row.Id],
                };
                this.$api.publishManageAPI
                    .getProcessAddManList(Qs.stringify(params))
                    .then((res) => {
                        if (res.data.Success == false) {
                            VXETable.modal.message({
                                content: res.data.Message,
                                status: "error",
                            });
                            return;
                        }
                        console.log(res.data.Data);
                        this.formInputStop.formData =
                            res.data.Data.dataTable[0];
                        this.formInputStop.isShow = true;
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            } else if (row.auditType === "4") {
                const params = {
                    uid: this.$store.state.userID,
                    email: this.$store.state.email,
                    currentPage: 1,
                    pageSize: 100,
                    searchKey: ["", row.Id],
                };
                this.$api.publishManageAPI
                    .getProcessAddManList(Qs.stringify(params))
                    .then((res) => {
                        if (res.data.Success == false) {
                            VXETable.modal.message({
                                content: res.data.Message,
                                status: "error",
                            });
                            return;
                        }
                        console.log(res.data.Data);
                        this.formInputStart.formData =
                            res.data.Data.dataTable[0];
                        this.formInputStart.isShow = true;
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            } else if (row.auditType === "5") {
                const params = {
                    uid: this.$store.state.userID,
                    email: this.$store.state.email,
                    currentPage: 1,
                    pageSize: 20,
                    searchKey: [row.Id],
                };
                this.$api.publishManageAPI
                    .getPublishOne(Qs.stringify(params))
                    .then((res) => {
                        if (res.data.Success === false) {
                            VXETable.modal.message({
                                content: res.data.Message,
                                status: "error",
                            });
                            return;
                        }

                        this.formInputRetire.formData.Id = res.data.Data.Id;
                        this.formInputRetire.formData.ProcessID =
                            res.data.Data.ProcessID;
                        this.formInputRetire.formData.ProcessName =
                            res.data.Data.ProcessName;
                        this.formInputRetire.formData.DevelopUser =
                            res.data.Data.DevelopUser;
                        this.formInputRetire.formData.DevelopUserUID =
                            res.data.Data.DevelopUserUID;
                        this.formInputRetire.formData.leader =
                            res.data.Data.leader;
                        this.formInputRetire.formData.leaderUID =
                            res.data.Data.leaderUID;
                        this.formInputRetire.formData.retireReason =
                            res.data.Data.retireReason;
                        this.formInputRetire.isShow = true;
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            } else if (row.auditType === "6") {
                const params = {
                    uid: this.$store.state.userID,
                    email: this.$store.state.email,
                    currentPage: 1,
                    pageSize: 100,
                    searchKey: ["", row.Id],
                };
                this.$api.publishManageAPI
                    .getProcessAddManList(Qs.stringify(params))
                    .then((res) => {
                        if (res.data.Success == false) {
                            VXETable.modal.message({
                                content: res.data.Message,
                                status: "error",
                            });
                            return;
                        }
                        console.log(res.data.Data);
                        this.formInputAddMan.formData =
                            res.data.Data.dataTable[0];
                        this.formInputAddMan.isShow = true;
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            } else if (row.auditType === "7") {
                const params = {
                    uid: this.$store.state.userID,
                    email: this.$store.state.email,
                    currentPage: 1,
                    pageSize: 100,
                    searchKey: ["", row.Id],
                };
                this.$api.publishManageAPI
                    .getProcessAddManList(Qs.stringify(params))
                    .then((res) => {
                        if (res.data.Success == false) {
                            VXETable.modal.message({
                                content: res.data.Message,
                                status: "error",
                            });
                            return;
                        }
                        console.log(res.data.Data);
                        this.formInputStop.formData =
                            res.data.Data.dataTable[0];
                        this.formInputStop.isShow = true;
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            } else if (row.auditType === "8") {
                const params = {
                    uid: this.$store.state.userID,
                    email: this.$store.state.email,
                    currentPage: 1,
                    pageSize: 100,
                    searchKey: ["", row.Id],
                };
                this.$api.publishManageAPI
                    .getProcessAddManList(Qs.stringify(params))
                    .then((res) => {
                        if (res.data.Success == false) {
                            VXETable.modal.message({
                                content: res.data.Message,
                                status: "error",
                            });
                            return;
                        }
                        console.log(res.data.Data);
                        this.formInputStart.formData =
                            res.data.Data.dataTable[0];
                        this.formInputStart.isShow = true;
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            } else if (row.auditType === "9") {
                this.$refs.frequencyChangeApplyRef.audit(row)
            } else if (row.auditType === "10") {
                this.$refs.empTypeChangeApplyRef.audit(row)
            }
        },
        calTableHeight(rowsLength) {
            let minHeight = window.innerHeight - (65 + 28 + 198);
            let calHeight = rowsLength == null ? 0 : (rowsLength + 1) * 36 + 22;
            this.tableHeight = Math.max(minHeight, calHeight);
        },
        findData() {
            const params = {
                uid: this.getUserId,
                email: this.getUserEmail,
                currentPage: this.tablePager.currentPage,
                pageSize: this.tablePager.pageSize,
                searchKey: [this.toolbar.formData.searchKey], //
            };
            this.$api.newPublishManageAPI
                .getAuditList(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    // console.log(res.data.Data);
                    this.tableData = res.data.Data.dataTable;
                    this.tablePager.currentPage = res.data.Data.currentPage;
                    this.tablePager.pageSize = res.data.Data.pageSize;
                    this.tablePager.totalResult = res.data.Data.totalResult;
                    this.tableHeight = this.$calTableHeight(
                        res.data.Data.dataTable.length
                    );
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        handlePageChange() {
            this.findData();
        },
        async rejectRetire() {
            if (this.auditOpinionRPARetire === "OK") {
                VXETable.modal.message({
                    content: "驳回请修改默认审核意见",
                    status: "error",
                });
                return;
            }
            const type = await VXETable.modal.confirm("您确定要驳回吗?");

            if (type === "confirm") {
                const params = {
                    Id: this.formInputRetire.formData.Id,
                    status: "5", //驳回 改回已审核
                    auditMan: this.getUserId,
                };
                this.$api.requireManageAPI
                    .auditRPARetire(Qs.stringify(params))
                    .then((res) => {
                        if (res.data.Success === false) {
                            VXETable.modal.message({
                                content: res.data.Message,
                                status: "error",
                            });
                            return;
                        }
                        const auditNode = "科长审核";
                        //审核记录
                        this.addAuditRecord(
                            this.formInputRetire.formData.Id,
                            "2",
                            auditNode,
                            this.auditOpinionRPARetire
                        );

                        VXETable.modal.message({
                            content: "驳回成功",
                            status: "success",
                        });
                        this.formInputRetire.isShow = false;
                        this.findData();
                        //  this.$emit("freshAuditNum");
                        //  this.$parent.getAuditNum();
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            }
        },
        submitRetire() {
            if (this.auditOpinionRPARetire === "") {
                VXETable.modal.message({
                    content: "审核意见不能为空",
                    status: "error",
                });
                return;
            }

            const params = {
                Id: this.formInputRetire.formData.Id,
                status: "7",
                auditMan: this.getUserId,
            };
            this.$api.requireManageAPI
                .auditRPARetire(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success === false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }

                    const auditNode = "总部窗口审核";
                    //审核记录
                    this.addAuditRecord(
                        this.formInputRetire.formData.Id,
                        "1",
                        auditNode,
                        this.auditOpinionRPARetire
                    );

                    VXETable.modal.message({
                        content: "审核成功",
                        status: "success",
                    });
                    this.formInputRetire.isShow = false;
                    this.findData();
                    // this.$emit("freshAuditNum");
                    // this.$parent.getAuditNum();
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        async rejectAddMan() {
            if (this.auditOpinionAddMan === "OK") {
                VXETable.modal.message({
                    content: "驳回请修改默认审核意见",
                    status: "error",
                });
                return;
            }
            const type = await VXETable.modal.confirm("您确定要驳回吗?");

            if (type === "confirm") {
                const params = {
                    Id: this.formInputAddMan.formData.Id,
                    status: "3", //驳回 改回已审核
                    auditMan: this.getUserId,
                    type: "1",
                };
                this.$api.requireManageAPI
                    .auditRPAAddMan(Qs.stringify(params))
                    .then((res) => {
                        if (res.data.Success === false) {
                            VXETable.modal.message({
                                content: res.data.Message,
                                status: "error",
                            });
                            return;
                        }
                        const auditNode = "CoE审核";
                        //审核记录
                        this.addAuditRecord(
                            this.formInputAddMan.formData.Id,
                            "2",
                            auditNode,
                            this.auditOpinionAddMan
                        );

                        VXETable.modal.message({
                            content: "驳回成功",
                            status: "success",
                        });
                        this.formInputAddMan.isShow = false;
                        this.findData();
                        //  this.$emit("freshAuditNum");
                        //  this.$parent.getAuditNum();
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            }
        },
        submitAddMan() {
            if (this.auditOpinionAddMan === "") {
                VXETable.modal.message({
                    content: "审核意见不能为空",
                    status: "error",
                });
                return;
            }

            const params = {
                Id: this.formInputAddMan.formData.Id,
                status: "2",
                auditMan: this.getUserId,
                type: "1",
            };
            this.$api.requireManageAPI
                .auditRPAAddMan(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success === false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }

                    const auditNode = "CoE审核";
                    //审核记录
                    this.addAuditRecord(
                        this.formInputAddMan.formData.Id,
                        "1",
                        auditNode,
                        this.auditOpinionAddMan
                    );

                    VXETable.modal.message({
                        content: "审核成功",
                        status: "success",
                    });
                    this.formInputAddMan.isShow = false;
                    this.findData();
                    // this.$emit("freshAuditNum");
                    // this.$parent.getAuditNum();
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        async rejectStop() {
            if (this.auditOpinionStop === "OK") {
                VXETable.modal.message({
                    content: "驳回请修改默认审核意见",
                    status: "error",
                });
                return;
            }
            const type = await VXETable.modal.confirm("您确定要驳回吗?");

            if (type === "confirm") {
                const params = {
                    Id: this.formInputStop.formData.Id,
                    status: "3", //驳回 改回已审核
                    auditMan: this.getUserId,
                    type: "2",
                };
                this.$api.requireManageAPI
                    .auditRPAAddMan(Qs.stringify(params))
                    .then((res) => {
                        if (res.data.Success === false) {
                            VXETable.modal.message({
                                content: res.data.Message,
                                status: "error",
                            });
                            return;
                        }
                        const auditNode = "CoE审核";
                        //审核记录
                        this.addAuditRecord(
                            this.formInputStop.formData.Id,
                            "2",
                            auditNode,
                            this.auditOpinionStop
                        );

                        VXETable.modal.message({
                            content: "驳回成功",
                            status: "success",
                        });
                        this.formInputStop.isShow = false;
                        this.findData();
                        //  this.$emit("freshAuditNum");
                        //  this.$parent.getAuditNum();
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            }
        },
        submitStop() {
            if (this.auditOpinionStop === "") {
                VXETable.modal.message({
                    content: "审核意见不能为空",
                    status: "error",
                });
                return;
            }

            const params = {
                Id: this.formInputStop.formData.Id,
                status: "2",
                auditMan: this.getUserId,
                type: "2",
            };
            this.$api.requireManageAPI
                .auditRPAAddMan(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success === false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }

                    const auditNode = "CoE审核";
                    //审核记录
                    this.addAuditRecord(
                        this.formInputStop.formData.Id,
                        "1",
                        auditNode,
                        this.auditOpinionStop
                    );

                    VXETable.modal.message({
                        content: "审核成功",
                        status: "success",
                    });
                    this.formInputStop.isShow = false;
                    this.findData();
                    // this.$emit("freshAuditNum");
                    // this.$parent.getAuditNum();
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        async rejectStart() {
            if (this.auditOpinionStart === "OK") {
                VXETable.modal.message({
                    content: "驳回请修改默认审核意见",
                    status: "error",
                });
                return;
            }
            const type = await VXETable.modal.confirm("您确定要驳回吗?");

            if (type === "confirm") {
                const params = {
                    Id: this.formInputStart.formData.Id,
                    status: "3", //驳回 改回已审核
                    auditMan: this.getUserId,
                    type: "3",
                };
                this.$api.requireManageAPI
                    .auditRPAAddMan(Qs.stringify(params))
                    .then((res) => {
                        if (res.data.Success === false) {
                            VXETable.modal.message({
                                content: res.data.Message,
                                status: "error",
                            });
                            return;
                        }
                        const auditNode = "CoE审核";
                        //审核记录
                        this.addAuditRecord(
                            this.formInputStart.formData.Id,
                            "2",
                            auditNode,
                            this.auditOpinionStart
                        );

                        VXETable.modal.message({
                            content: "驳回成功",
                            status: "success",
                        });
                        this.formInputStart.isShow = false;
                        this.findData();
                        //  this.$emit("freshAuditNum");
                        //  this.$parent.getAuditNum();
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            }
        },
        submitStart() {
            if (this.auditOpinionStart === "") {
                VXETable.modal.message({
                    content: "审核意见不能为空",
                    status: "error",
                });
                return;
            }

            const params = {
                Id: this.formInputStart.formData.Id,
                status: "2",
                auditMan: this.getUserId,
                type: "3",
            };
            this.$api.requireManageAPI
                .auditRPAAddMan(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success === false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }

                    const auditNode = "CoE审核";
                    //审核记录
                    this.addAuditRecord(
                        this.formInputStart.formData.Id,
                        "1",
                        auditNode,
                        this.auditOpinionStart
                    );

                    VXETable.modal.message({
                        content: "审核成功",
                        status: "success",
                    });
                    this.formInputStart.isShow = false;
                    this.findData();
                    // this.$emit("freshAuditNum");
                    // this.$parent.getAuditNum();
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        showAuditList(row) {
            const params = {
                uid: this.getUserId,
                email: this.getUserEmail,
                currentPage: 1,
                pageSize: 1,
                searchKey: [row.Id], //
            };
            this.$api.requireManageAPI
                .getAuditRecordList(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    // console.log(res.data.Data);
                    this.dtAudit = res.data.Data;
                    this.isShowAudit = true;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        addAuditRecord(bussId, status, auditNode, auditOpinion) {
            //写审核日志
            const params = {
                auditBuId: bussId,
                auditMan: this.getUserName,
                auditManUid: this.getUserId,
                auditStatus: status, //1 通过 2 驳回
                auditOpinion: auditOpinion,
                auditNode: auditNode,
            };
            this.$api.requireManageAPI
                .addAuditRecord(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success === false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        clear() {
            this.toolbar.formData.searchKey = "";
            this.toolbar.formData.status = "";
        },
        closeWinEvent() {
            this.findData();
        },
        keydown(e) {
            if (e.keyCode === 13) {
                this.findData();
            }
        },
    },
    mounted() {
        this.findData();
        window.addEventListener("keydown", this.keydown);
    },
    unmounted() {
        window.removeEventListener("keydown", this.keydown, false);
    },
    computed: {
        getUserName() {
            return this.$store.state.userName;
        },
        getJobZb() {
            return this.$store.state.jobZb;
        },
        getJobName() {
            return this.$store.state.jobName;
        },
        getUserEmail() {
            return this.$store.state.email;
        },
        getUserId() {
            return this.$store.state.userID;
        },
    },
};
</script>

<style type="text/css">
td.vxe-body--column {
    vertical-align: middle;
}
</style>
